import React from 'react';
import { BD, BD_OVERLAY_GRADIENT } from '../bookDemoTheme';

/** Two blurred accent glows plus a soft vignette. Purely decorative, no assets. */
const BackgroundDecor: React.FC = () => (
  <>
    <div
      className={`pointer-events-none absolute bottom-[-140px] sm:bottom-[-46px] left-[-36px] blur-[300px] sm:blur-[200px] w-[372px] h-[372px] rounded-full ${BD.glowBg}`}
      aria-hidden="true"
    />
    <div
      className={`pointer-events-none hidden sm:block absolute bottom-[-78px] right-[-30px] blur-[200px] w-[286px] h-[286px] rounded-full ${BD.glowBg}`}
      aria-hidden="true"
    />
    <div
      className="pointer-events-none absolute inset-0"
      style={{ backgroundImage: BD_OVERLAY_GRADIENT }}
      aria-hidden="true"
    />
  </>
);

export default BackgroundDecor;
